/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';

const ButtonWrapper = styled.button`
	font-size: 19px;
	font-weight: 700;
	color: #fff;
	background: #2ECC71;
	width: ${({width}) => width ? width : 'auto'};
	padding: 8px 18px 11px;
	border: 1px solid #43ABF3;
	border-radius: 3px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
`;


const Button = ({handleClick, width}) => (
    <ButtonWrapper onClick={handleClick} width={width}>
        Übernehmen
    </ButtonWrapper>
);

export default Button;


// WEBPACK FOOTER //
// ./src/components/task/shop/form/button.js